// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    name: {
        title: '用户名',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入用户名'
        }]
    },
    nickname: {
        title: '昵称',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入昵称'
        }]
    },
    password: {
        title: '密码',
        type: 'input',
        aliasType: 'password',
        value: '',
        placeholder: '请输入密码，默认密码为 123456'
    },
    role_id: {
        title: '角色名称',
        type: 'select',
        value: '',
        items: [],
        rules: [{
            required: true,
            message: '请选择角色名称'
        }]
    },

}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '用户名',
    dataIndex: 'name',
    key: 'name',
    ...columnPublicConfig,
},
{
    title: '昵称',
    dataIndex: 'nickname',
    key: 'nickname',
    ...columnPublicConfig,
},
{
    title: '角色',
    dataIndex: 'rolename',
    filterIndex: 'role_id',
    key: 'role_id',
    type: 'select',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '关联用户',
    dataIndex: 'jxslist',
    key: 'jxslist',
    scopedSlots: {
        customRender: 'c-assoc'
    },
    ...columnPublicConfig
},
{
    title: '修改时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    ...columnPublicConfig
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 160,
    scopedSlots: {
        customRender: 'c-action'
    }
}]
